(function () {
  const track = document.getElementById('track');
  const cards = Array.from(track.children);
  const navBottom = document.getElementById('navBottom');
  const slider = document.getElementById('slider');

  let currentPage = 0;
  let startX = 0;
  let isDragging = false;
  let prevTranslate = 0;

  function buildPaginationDots() {
    navBottom.innerHTML = '';

    cards.forEach((_, index) => {
      const dotElement = document.createElement('span');
      dotElement.className = index === currentPage ? 'dot active' : 'dot';
      dotElement.addEventListener('click', () => goToPage(index));
      navBottom.appendChild(dotElement);
    });
  }

  function setPosition() {
    const containerWidth = slider.clientWidth;
    const cardWidth = cards[0].offsetWidth + 16; // gap
    const translateX = -currentPage * cardWidth + (containerWidth - cardWidth) / 2;
    track.style.transform = `translateX(${translateX}px)`;
  }

  function goToPage(n) {
    currentPage = Math.max(0, Math.min(n, cards.length - 1));
    setPosition();
    updateDots();
    updateActiveCard();
  }

  function updateActiveCard() {
    cards.forEach((card, idx) => {
      card.classList.toggle('active', idx === currentPage);
    });
  }

  function updateDots() {
    Array.from(navBottom.children).forEach((el, idx) => el.classList.toggle('active', idx === currentPage));
  }

  function touchStart(e) {
    startX = e.touches[0].clientX;
    isDragging = true;
  }

  function touchMove(e) {
    if (!isDragging) return;
    const currentX = e.touches[0].clientX;
    const deltaX = currentX - startX;
    track.style.transform = `translateX(${prevTranslate + deltaX}px)`;
  }

  function touchEnd(e) {
    if (!isDragging) return;
    const endX = e.changedTouches[0].clientX;
    const deltaX = endX - startX;
    if (Math.abs(deltaX) > 30) {
      if (deltaX < 0) goToPage(currentPage + 1);
      else goToPage(currentPage - 1);
    } else {
      setPosition();
    }
    prevTranslate = parseFloat(track.style.transform.replace('translateX(', '').replace('px)', '')) || 0;
    isDragging = false;
  }

  track.addEventListener('touchstart', touchStart);
  track.addEventListener('touchmove', touchMove);
  track.addEventListener('touchend', touchEnd);

  buildPaginationDots();
  setPosition();
  updateDots();
})();
